import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.flashCardsStepThreeExtraCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.flashCardsStepThreeExtraCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) =>
    state.flashCardsStepThreeExtraCollections.data
      .flashCardsStepThreeExtraCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.flashCardsStepThreeExtraCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
